import { h, Component } from "preact";
import { connect } from "react-redux";
import Picture from "./Picture";
import { currency } from "../utils/Format";
import { loadSummary } from "../state/actions/orderSummaryActions";
import config from "../config";
import DiscountCode from "./DiscountCode";
import OrderCharityMsg from "./OrderCharityMsg";
import { css } from "preact-emotion";

const feesStr = css({
  color: "#5A626C",
  fontSize: 11,
  fontWeight: "normal"
});
const yourOrder = css({
  background: "#F7FAFF",
  marginBottom: 24,
  borderRadius: 4,
  boxShadow: "0 1px 4px 0 rgba(32, 7, 64, 0.13)",
  backgroundColor: "#f9f9fa",
  "@media(max-width:600px)": {
    ".table th": {
      padding: "9px 12px"
    },
    ".table td": {
      padding: "9px 12px"
    }
  },
  h3: {
    margin: 0
  }
});

const yourOrderHeading = css({
  padding: 18,
  "@media(max-width:600px)": {
    padding: 12
  }
});

class YourOrderWrapper extends Component {
  eventLoad = () => {
    const {
      event,
      ticketSelection,
      loadSummary,
      order,
      merchandise
    } = this.props;
    const tickets = ticketSelection.requestedTickets
      ? ticketSelection.requestedTickets
      : ticketSelection.tickets;
    const clientDonation = order && order.data ? order.data.clientDonation : 0;
    loadSummary(
      event.id,
      tickets,
      clientDonation,
      order,
      merchandise.merch.display
    );
  };
  globalLoad = () => {
    const { loadSummary, giftCards } = this.props;
    const { giftCardPage, giftCardsOrder } = giftCards;
    loadSummary(giftCardPage.userId, [], 0, {}, [], giftCardsOrder, false);
  };

  render() {
    const { isGlobal } = this.props;
    const load = isGlobal ? this.globalLoad : this.eventLoad;
    return <YourOrder load={load} {...this.props} />;
  }
}

class YourOrder extends Component {
  componentDidMount() {
    const { event, orderSummary, ticketSelection, load } = this.props;
    if (!orderSummary.loading && !orderSummary.data) {
      load();
    }
  }

  componentDidUpdate(perviousProps) {
    const { order, load } = this.props;
    if (
      perviousProps.order &&
      order &&
      order.paymentMethod !== perviousProps.order.paymentMethod
    ) {
      load();
    }
  }

  render({ orderSummary, order, event, allowDiscountsAdd = false, load }) {
    const currencyCode = config("CURRENCY");
    const valueCel = {
      textAlign: "right"
    };
    if (orderSummary.error) {
      return (
        <div>
          <h2>Your order</h2>
          <p>{orderSummary.error}</p>
          <button onClick={load} class="btn" aria-label="Retry button">
            Retry
          </button>
        </div>
      );
    }

    return (
      <div className={yourOrder}>
        {event.data ? (
          <div class="hide-mobile">
            <Picture
              img={event.data.displayImage}
              width={600}
              alt={`${event.data.name} Event Banner`}
            />
          </div>
        ) : (
          ""
        )}
        <div className={yourOrderHeading}>
          <h3 style={{ fontWeight: 600, margin: 0 }}>Your order</h3>
          {orderSummary.loading ||
          !orderSummary.data ||
          !orderSummary.data.eventDate ? (
            ""
          ) : (
            <p>
              {orderSummary.data.eventDate.time},{" "}
              {orderSummary.data.eventDate.date}
            </p>
          )}
        </div>
        {orderSummary.loading ||
        !orderSummary.data ||
        order.addDiscountRequest.loading ||
        order.removeDiscountRequest.loading ? (
          <div class="loading loading-lg" style={{ padding: "0 0 180px 0" }} />
        ) : (
          <div>
            {!allowDiscountsAdd ? (
              <div style={{ padding: "0 18px" }}>
                <DiscountCode allowAdd={false} />
              </div>
            ) : null}
            <table class="table">
              {orderSummary.data.ticketSummary.map((line, index) => (
                <tr class="border">
                  <th>
                    {line.label}{" "}
                    {orderSummary.data.taxes && line.total ? (
                      <span className={feesStr}>inc GST</span>
                    ) : null}
                    {line.includesMsg ? (
                      <p
                        dangerouslySetInnerHTML={{
                          __html: line.includesMsg
                        }}
                      />
                    ) : null}
                  </th>
                  <td data-cy={`ticket-${line.label}`} style={valueCel}>
                    {currency(line.total, { prefix: currencyCode })}
                  </td>
                </tr>
              ))}

              {orderSummary.data.merchandiseSummary.map((line, index) => (
                <tr>
                  <th>{line.label} </th>
                  <td data-cy={`merch-${line.label}`} style={valueCel}>
                    {currency(line.total, { prefix: currencyCode })}
                  </td>
                </tr>
              ))}

              {orderSummary.data.giftCardSummary.map((line, index) => (
                <tr>
                  <th>{line.label} </th>
                  <td data-cy={`gift-card-${line.label}`} style={valueCel}>
                    {currency(line.total, { prefix: currencyCode })}
                  </td>
                </tr>
              ))}
              {orderSummary.data.clientDonation ? (
                <tr>
                  <th>Donation</th>
                  <td data-cy={`client-donation`} style={valueCel}>
                    {currency(orderSummary.data.clientDonation, {
                      prefix: currencyCode
                    })}
                  </td>
                </tr>
              ) : null}
              <tr class="border">
                <th>Subtotal</th>
                <td data-cy={`sub-total`} style={valueCel}>
                  {currency(orderSummary.data.subtotal, {
                    prefix: currencyCode
                  })}
                </td>
              </tr>

              {orderSummary.data.discounts ? (
                <tr>
                  <th>Discounts</th>
                  <td data-cy={`discounts`} style={valueCel}>
                    {currency(orderSummary.data.discounts, {
                      prefix: currencyCode
                    })}
                  </td>
                </tr>
              ) : (
                ""
              )}
              {orderSummary.data && orderSummary.data.giftCardCredit > 0 ? (
                <tr>
                  <th>Gift card</th>
                  <td data-cy={`gift-card`} style={valueCel}>
                    {currency(orderSummary.data.giftCardCredit, {
                      prefix: currencyCode
                    })}
                  </td>
                </tr>
              ) : (
                ""
              )}
              {orderSummary.data.autoDiscountSummaries &&
              orderSummary.data.autoDiscountSummaries.length ? (
                <tr>
                  <td colspan="2">
                    {orderSummary.data.autoDiscountSummaries.join(", ")}
                  </td>
                </tr>
              ) : (
                ""
              )}

              {orderSummary.data.passedOnFee ? (
                <tr>
                  <th style={{ paddingBottom: 8 }}>
                    Booking Fees <span className={feesStr}>inc GST</span>
                  </th>
                  <td
                    data-cy={`booking-fee`}
                    style={{ ...valueCel, paddingBottom: 8 }}
                  >
                    {currency(orderSummary.data.passedOnFee, {
                      prefix: currencyCode
                    })}
                  </td>
                </tr>
              ) : null}

              {event.data && event.data.showCharity ? (
                <tr class="border">
                  <td colspan="2">
                    <OrderCharityMsg charity={event.data.charity} />
                  </td>
                </tr>
              ) : null}
              <tr class="border">
                <td>
                  <h3>Total</h3>
                </td>
                <td style={valueCel}>
                  <h3 data-cy={`total`} role="presentation">
                    {currency(orderSummary.data.outstandingAmount, {
                      prefix: currencyCode
                    })}
                  </h3>
                </td>
              </tr>
            </table>
          </div>
        )}
      </div>
    );
  }
}

export default connect(
  (state, ownProps) => ({
    order: state.order,
    orderSummary: state.orderSummary,
    event: state.event,
    ticketSelection: state.ticketSelection,
    merchandise: state.merchandise,
    giftCards: state.giftCards
  }),
  { loadSummary }
)(YourOrderWrapper);



// WEBPACK FOOTER //
// ./components/YourOrder.js